var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.doughnutsChartPaymentMethod).length > 0)?_c('div',[_c('doughnut-chart',{attrs:{"id":"doughnut-chart-size","height":_vm.height,"dataTableByPaymentMethod":_vm.dataTableByPaymentMethod,"chart-data":_vm.doughnutsChartPaymentMethod.chartData,"extra-options":_vm.doughnutsChartPaymentMethod.extraOptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }